angular.module("app").directive("isAllowedToChange", [
    '$compile',
    function ($compile) {
        return {
            restrict: "A",
            replace: true,
            link: function ($scope, element, attributes) {
                var modelName = attributes.ngModel,
                    model,
                    elementValue,
                    elementName = attributes.name,
                    template = "<span>{{{value}}}</span>",
                    modelNameArray = modelName.split(".");

                if (!!modelName && modelName.indexOf(".") > -1) {
                    model = modelNameArray[0];
                    modelNameArray.shift();
                    elementValue = modelNameArray.join(".");
                } else {
                    return
                }

                if (!!elementName &&
                    !!$scope[model]["notChangeable"] &&
                    $scope[model]["notChangeable"].length &&
                    $scope[model]["notChangeable"].indexOf(elementName) > -1) {

                    template = template.replace("{{{value}}}", "{{" + model + "." + elementValue + "}}");
                    template = angular.element(template);
                    $(element).replaceWith(template);
                    $compile(template)($scope);
                }
            }
        }
    }
]);